<template>
  <div id="serviceDetails">
    <div class="service_header" style="background: #FCFCFC;">
      <div class="collapse_buttons" v-show="hasEditMode">
        <div @click="showEditMode" v-if="!editMode">
          <pt-icon type="icon-bianji1" class="edit_icon"></pt-icon>
        </div>
        <div v-if="editMode">
          <a-button @click="editMode = false" style="margin-right: 10px;" size="small">
            {{$t('baseVO.cacel')}}
          </a-button>
          <a-button  type="primary" :loading="saveLoading" @click="updateService" size="small">
            {{$t('baseVO.save')}}
          </a-button>
        </div>
      </div>
    </div>
    <template v-if="!editMode">
      <div class="service_info">
        <a-row class="title">
          <a-col :span="12">
            <div>{{$t('deal.service.addService.serviceTime')}}</div>
          </a-col>
          <a-col :span="12">
            <div>{{$t('deal.service.addService.serviceAccount')}}</div>
          </a-col>
        </a-row>
        <a-row class="content">
          <a-col :span="12">
            <div class="content">{{serviceVO.serviceTime != '~' ? $moment(serviceVO.serviceTime) : '~'| dayjs}}</div>
          </a-col>
          <a-col :span="12">
            <div class="content">
              <a-tooltip placement="top" :title="accountDOS">
                <div class="accountdos">
                  {{accountDOS}}
                </div>
              </a-tooltip>
            </div>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <div>{{$t('deal.service.addService.content')}}</div>
          </a-col>
        </a-row>
        <a-row class="content">
          <a-col>
            <div>{{serviceVO.content}}</div>
          </a-col>
        </a-row>
        <a-row>
          <a-row>
            <div class="title">
          {{$t('deal.service.addService.serviceFile')}}
            </div>
            <a-divider style="margin:0;"></a-divider>
            <div class="fileDiv">
              <div v-if="serviceVO && serviceVO.serviceFileVOS && serviceVO.serviceFileVOS.length > 0">
                <div v-for="(item,index) in serviceVO.serviceFileVOS" :key="index" class="fileItem">
                  <pt-icon type="icon-fujian2" class="fileIcon"></pt-icon>
                  <div class="fileName">{{item.fileName}}</div>
                  <div style="display: flex;align-items: center;">
                    <div @click="previewFile(item)"  v-if="$util.matchPreviewType(item.fileName)">
                      <pt-icon class="previewIcon" type="icon-yulancopy" :title="$t('baseVO.preview')"></pt-icon>
                    </div>
                    <div @click="downloadFile(item)" style="margin-left: 20px;">
                      <pt-icon class="downloadIcon" type="icon-xiazai" :title="$t('baseVO.download')"></pt-icon>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="noFileClass">
                {{$t('baseVO.empty')}}
              </div>
            </div>
          </a-row>
        </a-row>
      </div>
    </template>
    <template v-else>
      <addService :serviceVO="serviceVO" ref="addServiceRef" @saveServiceSuccess="saveServiceSuccess"></addService>
    </template>
  </div>
</template>

<script>
  import addService from './addService'
  import ARow from 'ant-design-vue/es/grid/Row'
  export default {
    name: 'serviceDetails',
    components:{
      ARow,
      addService
    },
    props: {
      hasEditMode:{
        type: Boolean,
        default: false
      },
      serviceVO:{
        type: Object,
        default: ()=> {},
      },
      index:{
        type: Number,
        default: 1
      }
    },
    data() {
      return {
        editMode: false,
        saveLoading:false,
      }
    },
    computed:{
      accountDOS(){
        if(this.serviceVO && this.serviceVO.accountDOS.length > 0){
          let accountList = this.serviceVO.accountDOS
          let accountDOS = this.serviceVO.serviceAccountDOS.map(e=>{
            return accountList.find(f => { return f.id == e.accountId }).loginName
          })
          return accountDOS.join(',')
        }else{
          return '~'
        }
      }
    },
    mounted() {

    },
    methods: {
      showEditMode(){
        this.editMode = true

      },

      previewFile(file){
        this.$util.previewFile(file.id)
      },
      downloadFile(file){
        this.$util.dowLoadFile(file.id,file.fileName,this);
      },
      saveServiceSuccess(){
        this.editMode = false
        this.$emit('saveServiceSuccess')
      },
      updateService(){
        this.$refs.addServiceRef.submit()
      }
    }
  }
</script>

<style scoped lang="less">
  #serviceDetails{
    padding: 10px 0;
    .service_header{
      display: flex;
      flex-direction: row;
    }
    .title{
      font-size: 12px;
      color: #999999;
    }
    .content{
      font-size: 12px;
      color: #333333;
      margin-bottom: 10px;
    }
    .accountdos{
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .service_info{
      padding: 10px 20px;
      background: #FCFCFC;
      .fileDiv{
        padding: 0 10px;
        background: rgba(248,249,251,0.62);
        border-radius: 0 0 4px 4px;
      }
      .fileItem{
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 10px 0;
        border-bottom: 1px solid #E7E7E7;
        .fileIcon{
          font-size: 18px;
        }
        .fileName{
          flex:1;
          font-size: 12px;
          color: #333333;
          margin: 0 10px;
        }
        .delIcon{
          font-size: 20px;
          cursor: pointer;
        }
      }
      .fileItem:last-child{
        border-bottom: 0px;
      }
      .noFileClass{
        padding: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        color: #999999;
      }
    }
    .collapse_buttons{
      margin-right: 10px;
      flex:1;
      display:flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
    }
  }
</style>